import { ACTIVECART_TOGGLE_WIGGLE_EFFECT } from '../actionTypes/ActiveCartReminderActionTypes';

const initialState = {
    wiggleCart: false,
    showActiveCartModal: false,
};

const activeCartToggleWiggleReducer = function activeCartToggleWiggleReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case ACTIVECART_TOGGLE_WIGGLE_EFFECT: {
            return action.payload;
        }
        default:
            return state;
    }
};

activeCartToggleWiggleReducer.reducerName = 'toggleWiggleCart';

export default activeCartToggleWiggleReducer;
